<!-- Matter UI Revamp -->
<div class="container-fluid">
  <!-- Card: header + table + pagination -->
  <div class="table-container">

    <!-- Card Header Row -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">List of Matters</h2>
        <div class="header-actions">
          <!-- Search -->
          <div class="search-wrapper">
            <input type="text" class="search-input" placeholder="Search for Matter..." [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange($event)" (keydown)="preventLeadingSpace($event)">
            <img src="assets/img/search.svg" class="search-icon">
          </div>

          <!-- Create Button -->
          <button class="btn-create" (click)="onClick(selectedMatter)">
            <i class="fa fa-plus me-2"></i> Create Matter
          </button>
          
        </div>

      </div>
    </div>


    <!-- Table -->
    <div *ngIf="legalMatters.length > 0" class="table-responsive-wrapper">
    <table class="head-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <span>Title</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('title')" alt="Sort">
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Number</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('matter_id')" alt="Sort">
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Type</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('caseType')" alt="Sort">
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Date of Filing</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('date_of_filling')" alt="Sort">
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Clients</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('clients')" alt="Sort">
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Status</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('status')" alt="Sort">
            </div>
          </th>
          <th *ngIf="this.selectedOption == 'External Matters'">
            <div class="th-content">
              <span>External Counsels</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('owner.firm_name')" alt="Sort">
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Tags</span>
              <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sort('tags')" alt="Sort">
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let i of legalMatters | filter:searchText" class="table-row">
          <td>{{ i.title }}</td>
          <td>{{ i.matter_id }}</td>
          <td>{{ i.caseType }}</td>
          <td>{{ i.date_of_filling }}</td>

          <td>
            <span class="client-name" *ngFor="let client of i.clients; let i = index">
              {{ client?.name }}
            </span>
            <span class="client-name" *ngFor="let client of i.corporate; let i = index">
              {{ client?.name }}
            </span>
          </td>
          <td *ngIf="this.selectedOption=='External Matters'">{{i.owner?.firm_name}}</td>
          <td>{{ i.status | titlecase }}</td>
                  
          <td>
          <ng-container *ngIf="i.tags">
            <div *ngFor="let tag of getTagList(i.tags)">
                <span class="name-ellipsis" [ngClass]="{'no-ellipsis': tag.length <= 20}">{{ tag }}</span>
            </div>
          </ng-container>
        </td>

        <!-- <td *ngIf="this.selectedOption === 'External Matters'">
          <div class="dropdown">
            <button class="btn btn-primary actionbtn dropdown morebtn" aria-expanded="false" [ngClass]="{'disabled': i.isdisabled}"
              (click)="loadViewDetails(i,'external')">More Details</button>
          </div>
        </td> -->

        <td class="action-cell" *ngIf="this.selectedOption === 'External Matters'">
          <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu" [ngClass]="{'disabled': i.isdisabled }">
            <span class="action-dots">⋮</span>
          </button>
          <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
              <button mat-menu-item (click)="loadViewDetails(i,'external')">More Details</button>
          </mat-menu>
        </td>

        <td class="action-cell" *ngIf="this.selectedOption !== 'External Matters'">
          
          <!-- <button mat-icon-button class="action-btn" [matMenuTriggerFor]="actionMenu"
          [ngClass]="{'disabled': i.isdisabled || !i.is_editable}">
            <span class="action-dots">⋮</span>
          </button> -->
          <button mat-icon-button class="action-btn" 
          [matMenuTriggerFor]="isRestrictedPlan() ? null : actionMenu"
            (click)="checkPlan($event)" [ngClass]="{'disabled': i.isdisabled || !i.is_editable}">
            <span class="action-dots">⋮</span>
          </button>
        
          <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
              <button mat-menu-item (click)="loadViewDetails(i,'internal')">View Timeline</button>
              <button mat-menu-item (click)="loadEditMatterInfo(i)">Edit Matter</button>

              <!-- <button mat-menu-item *ngIf="product =='corporate'" (click)="updateGroups(i)">Update Department(s)</button> -->
            
              <button mat-menu-item *ngIf="i.status.toLowerCase() == 'active' || i.status.toLowerCase() == 'pending'" (click)="updateMatterStatus(i,'Closed')">Close Matter</button>
              <button mat-menu-item *ngIf="i.status.toLowerCase()  == 'closed'" (click)="updateMatterStatus(i,'Active')">Reopen Matter</button>
              <!-- <button mat-menu-item (click)="delete(i)">Delete</button>  -->
          </mat-menu>
        </td> 
        </tr>
      </tbody>
    </table>
    

    <!-- Pagination -->
    <div class="nav-buttons">
      <button class="prev" (click)="prev()" [disabled]="!relPrevCursor"> &lt;&lt; Prev </button>
      <button class="next" (click)="next()" [disabled]="!relNextCursor"> Next &gt;&gt;</button>
    </div>

    </div> 
            
    <!-- EMPTY STATE -->
    <div *ngIf="legalMatters?.length===0" class="empty-state-container">
      <!-- Search is server-side, so a non-matching keyword returns an empty
           list. Show "No results found" then, not the first-run empty state. -->
      <ng-container *ngIf="searchText?.trim(); else noMattersYet">
        <img src="assets/img/e-matter.png" class="empty-state-icon" alt="No results">
        <p class="empty-state-title">No results found</p>
        <p class="empty-state-subtitle">No matters match your search. Try a different keyword.</p>
      </ng-container>
      <ng-template #noMattersYet>
        <img src="assets/img/e-matter.png" class="empty-state-icon" alt="No entries">
        <p class="empty-state-title">No Matters Yet!</p>
        <p class="empty-state-subtitle">Secure and organize your matters by start creating it.</p>
      </ng-template>
    </div>

  </div>

</div>
<!-- Matter UI Revamp -->


<!-- Success Modal -->
  <div class="modal" id="successModal" tabindex="-1" *ngIf='successModel' aria-labelledby="successModalLabel" aria-hidden="true" style="display:block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <button type="button" class="btn-close remBtn" (click)="closeModal();ok();" data-bs-dismiss="modal" aria-label="Close"></button>
        <div class="modal-body">
          <div class="alertpara">
            <p class="alertparatxt">Success</p>
          </div>
        </div>
        <div class="alertext chn"> Congratulations! <br>You have successfully {{successGrpName}}</div>
        <div class="alertbutton">
          <button class="btn btn-default alertbtn btnbtn" (click)="closeModal();ok();">View Matter List</button>
        </div>
      </div>
    </div>
  </div>
<!-- Success Modal -->


<ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>